export default __webpack_public_path__ + "static/media/graph-money.ef6dec3e.svg";